import React, { Component } from 'react';
import Lottie from 'react-lottie';

import styles from "components/MathsMaster/PlayerStyles.module.scss";

import StarImg from "images/MathsMaster/star.png";
import CrossImg from "images/MathsMaster/cross.png";

export default class Player extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pointComponents: [],
            displayScore: 0,
        }
    }

    componentDidMount() {
        //if (!this.props.room || !this.props.room.state) return;
        //this.props.room.state.players[this.props.player.id].mathsData.listen("score", (value, prevValue) => {
        //    if (value > 0) {
        //        let pointComponents = [...this.state.pointComponents];
        //        pointComponents.push(<div key={`${this.props.player.id}-scoreAdd-${value}`} className={styles.pointAdd}>+{value-prevValue}</div>);
        //        this.setState({ pointComponents });
        //        setTimeout(() => {
        //            pointComponents = [...this.state.pointComponents];
        //            pointComponents.shift();
        //            this.setState({ pointComponents });
        //        }, 2000);
        //    }

        //    let displayScore = this.state.displayScore;
        //    let interval = setInterval(() => {
        //        if (displayScore < value) {
        //            displayScore++;
        //            this.setState({ displayScore });
        //        } else if (displayScore > value) {
        //            displayScore--;
        //            this.setState({ displayScore });
        //        } else {
        //            clearInterval(interval);
        //        }
        //    }, 100);
        //});
    }

    componentWillReceiveProps(nextProps) {

    }


    render() {
        return (
            <div id={`player-${this.props.player.id}`} className={`${styles.player} ${this.props.left ? "" : styles.reverse} ${this.props.player.showPlayer && styles.show}`}>
                <div id={`potato-${this.props.player.id}`} className={`${styles.potato}`}>
                    <div className={`${styles.nameAnchor} ${!this.props.left && styles.right}`} >
                        <div className={`${styles.name} ${!this.props.left && styles.right}`}>{this.props.player.name}</div>
                    </div>
                    <div className={`${styles.readyBox} ${this.props.player.mathsData.ready && styles.show}`}>READY</div>
                    <img style={{ width: "100%", height: "100%", padding: "5%", objectFit: "contain" , transform: "translateY(-5%)" }} src={this.props.player.avatar} alt="avatar" />
                </div>
                <div className={`${styles.textSection}`}>
                    <div className={`${styles.answerBox} ${this.props.player.mathsData.showAnswer && styles.show}`}>
                        <div className={styles.answerText}>{this.props.player.mathsData.submittedNumber}</div>
                        <div className={`${styles.arrow} ${styles.bg}`} />
                        <div className={styles.arrow} />
                        <div className={`${styles.answerValidation} ${this.props.player.mathsData.showValidation && styles.show}`} alt="answer validation">
                            <img src={StarImg} />
                            <div className={styles.count}>{this.props.player.mathsData.earnedPoints}</div>
                        </div>
                    </div>
                    <div className={`${styles.pointsRow}`}>
                        <img src={StarImg} className={`${styles.star}`} alt="player star"/>
                        <div className={`${styles.points}`}>{this.props.player.mathsData.score}</div>
                    </div>
                    {
                        this.state.pointComponents
                    }
                </div>
            </div>
        )
    }
}